import { toExcelRowNumber } from '../lib/stockImportsFormat'
import { formatMissingSkuReason } from '../lib/stockImportsMessages'
import {
  formatPriceCuts,
  PRICE_ISSUE_REASON_LABELS,
} from '../lib/stockImportsPriceLabels'
import stockCn from '../StockImportsTab/StockImportsTab.module.scss'
import type { StockImportsTableColumn } from '../StockImportsVirtualTable/StockImportsVirtualTable'
import tableCn from '../StockImportsVirtualTable/StockImportsVirtualTable.module.scss'
import type { MissingSkuItemDto } from '../types/stockImports.types'

export const missingSkuColumns: StockImportsTableColumn<MissingSkuItemDto>[] = [
  {
    header: 'Артикул (производителя)',
    accessorKey: 'article',
    width: 'minmax(110px, 1fr)',
  },
  {
    header: 'Артикул (поставщика)',
    accessorKey: 'articleInch',
    width: 'minmax(110px, 1fr)',
  },
  {
    id: 'barcode',
    header: 'Штрихкод',
    width: 'minmax(110px, 0.9fr)',
    cell: ({ row }) => row.original.barcode ?? '—',
  },
  { header: 'Бренд', accessorKey: 'brand', width: 'minmax(90px, 0.7fr)' },
  {
    header: 'Наименование',
    accessorKey: 'description',
    width: 'minmax(210px, 1.8fr)',
  },
  {
    id: 'quantity',
    header: 'Остаток',
    width: 'minmax(58px, 0.45fr)',
    cell: ({ row }) =>
      row.original.zeroStock ? (
        <span className={stockCn.previewZeroQuantity}>
          {row.original.quantity ?? 0}
        </span>
      ) : (
        (row.original.quantity ?? '—')
      ),
  },
  { header: 'Файл', accessorKey: 'fileName', width: 'minmax(150px, 1.1fr)' },
  {
    id: 'sheetName',
    header: 'Лист',
    width: 'minmax(90px, 0.6fr)',
    cell: ({ row }) => (
      <span className={tableCn.cellEllipsis} title={row.original.sheetName}>
        {row.original.sheetName}
      </span>
    ),
  },
  {
    id: 'rowIndex',
    header: 'Строка',
    width: 'minmax(62px, 0.45fr)',
    cell: ({ row }) => toExcelRowNumber(row.original.rowIndex),
  },
  {
    id: 'reason',
    header: 'Причина',
    width: 'minmax(210px, 1.8fr)',
    cell: ({ row }) =>
      formatMissingSkuReason(row.original.reason, row.original.searchedBy),
  },
]

const missingSkuPriceColumns: StockImportsTableColumn<MissingSkuItemDto>[] = [
  {
    id: 'rawPurchase',
    header: 'Закупка в файле',
    width: 'minmax(90px, 0.6fr)',
    cell: ({ row }) => row.original.rawPurchase ?? '—',
  },
  {
    id: 'rawRrc',
    header: 'РРЦ в файле',
    width: 'minmax(90px, 0.6fr)',
    cell: ({ row }) => row.original.rawRrc ?? '—',
  },
  {
    id: 'priceReason',
    header: 'Проблема цены',
    width: 'minmax(160px, 1.2fr)',
    cell: ({ row }) =>
      row.original.priceReason
        ? PRICE_ISSUE_REASON_LABELS[row.original.priceReason]
        : '',
  },
  {
    id: 'priceCuts',
    header: 'Убранные цены сегментов',
    width: 'minmax(180px, 1.4fr)',
    cell: ({ row }) => formatPriceCuts(row.original.priceCuts),
  },
  {
    id: 'priceSpikePercent',
    header: 'Скачок, %',
    width: 'minmax(70px, 0.5fr)',
    cell: ({ row }) => row.original.priceSpikePercent ?? '',
  },
]

export const missingSkuColumnsWithPrices = [
  ...missingSkuColumns,
  ...missingSkuPriceColumns,
]
